import { useQuery } from "@tanstack/react-query";
import WorkspacesService from "../services/WorkspacesService";

export const BRANDED_APP_TRANSFER_STATS_QUERY_KEY =
  "branded-app-transfer-stats";

export function useBrandedAppTransferStats() {
  return useQuery({
    queryKey: [BRANDED_APP_TRANSFER_STATS_QUERY_KEY],
    queryFn: () => WorkspacesService.getBrandedAppTransferStats(),
  });
}
